<template>
  <div class="fullscreen pattern d-flex justify-center align-center">
    <div class="context-container d-flex mx-4 align-center">
      <v-card
        outlined
        class="py-2 px-2 px-md-2 custom-elevation align-center d-flex flex-column flex-md-row">
        <div
          v-if="question.context_img"
          class="d-flex justify-center pt-6 pb-2 pa-md-0"
        >
          <v-img
            :src="$imageUrl(question.context_img, 'context/')"
            contain
            max-height="80px"
            max-width="124px"
          />
        </div>

        <v-card-title>
          {{ $localized(question, 'context') }}
        </v-card-title>
      </v-card>

      <v-btn
        large
        depressed
        rounded
        width="200"
        color="primary"
        class="my-4"
        @click="$emit('next')"
      >
        {{ $t('GAME.QUIZ.CONTEXT_NEXT') }}
      </v-btn>
    </div>
  </div>
</template>

<style scoped>

.v-card__title {
  font-size: 1rem;
  line-height: 1.4;
}

.fullscreen {
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1;
}

.context-container {
  max-width: 560px;
  width: 100%;
  flex-direction: column;
}
</style>

<script>
export default {
  name: 'QuizContext',
  props: {
    question: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
